import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EntradasService } from 'src/app/services/datos/entradas.service';

@Component({
  selector: 'app-panel-entradas-pendientes',
  templateUrl: './panel-entradas-pendientes.component.html',
  styleUrls: ['./panel-entradas-pendientes.component.scss']
})
export class PanelEntradasPendientesComponent implements OnInit {

  // Emitir cuando haya datos
  @Output() tieneContenido = new EventEmitter<boolean>();

  entradasTotales: any = null;
  maxEntradas: number = 0;

  constructor(private entradasSrv: EntradasService) { }

  ngOnInit(): void {
    this.cargaEntradasTotales();
  }


  cargaEntradasTotales() {
    this.entradasTotales = { entradasPendientes: [] };
    this.entradasSrv.entradasTotales().subscribe((resp) => {
      this.entradasTotales = resp.data;
      this.entradasTotales.entradasPendientes = resp.totales.entradasPendientes;

      console.log('__cargaEntradasTotales() ', this.entradasTotales);

      this.preparaChartEntradas();

      // Si hay datos, emitir tieneContenido
      if (this.entradasTotales.entradasPendientes?.length > 0) {
        this.tieneContenido.emit(true);
      }

    });
  }

  preparaChartEntradas() {
    if (!this.entradasTotales || !this.entradasTotales.entradasPendientes) {
      return;
    }

    // Ordenar entradas pendientes de mayor a menor número de entradas
    this.entradasTotales.entradasPendientes.sort((a: any, b: any) => b.num_entradas - a.num_entradas);

    // Máximo de entradas
    this.maxEntradas = Math.max(...this.entradasTotales.entradasPendientes.map((e: any) => e.num_entradas));

    const colors = ['bg-success', 'bg-warning', 'bg-orange', 'bg-teal', 'bg-lime', 'bg-deep-orange', 'bg-brown'];
    this.entradasTotales.entradasPendientes = this.entradasTotales.entradasPendientes.map((e: any, index: number) => {
      return {
        ...e,
        colorClass: colors[index % colors.length]
      };
    });
  }


}
